import { FaLayerGroup, FaGlobe, FaClipboardCheck, FaTruck, FaBriefcase } from 'react-icons/fa';
import { useTranslation } from "react-i18next";

const ServicesSection = () => {
    const { t } = useTranslation();
    const services = [
        {
            id: 1,
            title: t('service-1-title'),
            description: t('service-1-desc'),
            icon: FaLayerGroup,
        },
        {
            id: 2,
            title: t('service-2-title'),
            description: t('service-2-desc'),
            icon: FaGlobe,
        },
        {
            id: 3,
            title: t('service-3-title'),
            description: t('service-3-desc'),
            icon: FaClipboardCheck,
        },
        {
            id: 4,
            title: t('service-4-title'),
            description: t('service-4-desc'),
            icon: FaTruck,
        },
        {
            id: 5,
            title: t('service-5-title'),
            description: t('service-5-desc'),
            icon: FaBriefcase,
        },
    ];

    return (
        <section className="services_section layout_padding">
            <div className="container">
                <div className="heading_container heading_center">
                    <h1 className='fw-bold mb-3 text-secondary'>{t('why-us')}</h1>
                </div>
                <div className="row mt-5">
                        {services.map((service) => {
                            const Icon = service.icon;
                            return (
                            <div key={service.id} className="col-md-6 col-lg-4 mb-4">
                                <div className="service-card">
                                    <div className="service-icon"><Icon size={34} style={{display: 'block'}} /></div>
                                    <div className="service-content">
                                        <h4 className="service-title">{service.title}</h4>
                                        <p className="service-description">{service.description}</p>
                                    </div>
                                </div>
                            </div>
                            );
                        })}
                </div>
            </div>
        </section>
    );
};

export default ServicesSection;